var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1352_87058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 13.5V1.5C14.25 1.30109 14.171 1.11032 14.0303 0.96967C13.8897 0.829018 13.6989 0.75 13.5 0.75H1.5C1.30109 0.75 1.11032 0.829018 0.96967 0.96967C0.829018 1.11032 0.75 1.30109 0.75 1.5V13.5C0.75 13.6989 0.829018 13.8897 0.96967 14.0303C1.11032 14.171 1.30109 14.25 1.5 14.25H13.5C13.6989 14.25 13.8897 14.171 14.0303 14.0303C14.171 13.8897 14.25 13.6989 14.25 13.5ZM12.75 12.75H2.25V2.25H12.75V12.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.75H15V5.25H15.75V15.75H5.25V15H3.75V16.5C3.75 16.6989 3.82902 16.8897 3.96967 17.0303C4.11032 17.171 4.30109 17.25 4.5 17.25H16.5C16.6989 17.25 16.8897 17.171 17.0303 17.0303C17.171 16.8897 17.25 16.6989 17.25 16.5V4.5C17.25 4.30109 17.171 4.11032 17.0303 3.96967C16.8897 3.82902 16.6989 3.75 16.5 3.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74997 10.8212H8.24997V8.24948H10.8217V6.74948H8.24997V4.17773H6.74997V6.74948H4.17822V8.24948H6.74997V10.8212Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1352_87058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateIcon);
export default __webpack_public_path__ + "static/media/generateIcon.9cbdfa4be5ff8d2e5ae2efe85fd192dc.svg";
export { ForwardRef as ReactComponent };